import React, { useEffect, useMemo, useState } from "react";
import { ObterTemplatePreviewMensagem } from "../../../Services/WhatsApp";
import ChatTemplatePreview from "./ChatTemplatePreview";

const MensagemTemplate = ({ mensagem }) => {
    // ✅ PEGA O ID CORRETO A PARTIR DO SEU MODELO
    // Troque a prioridade conforme seu backend:
    const mensagemId =
        mensagem?.logConversasWhatsAppCodigoExterno;

    const initialPreview = mensagem?._templatePreview || null;

    const [preview, setPreview] = useState(initialPreview);
    const [loading, setLoading] = useState(!initialPreview);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        // ✅ Debug: se não tiver ID, você vai ver isso no console
        if (!mensagemId) {
            // Só loga quando for template e não tiver id (pra não poluir)
            console.warn("MensagemTemplate: mensagemId não encontrado na mensagem:", mensagem);
            setLoading(false);
            return;
        }

        if (initialPreview) return;

        let mounted = true;

        setLoading(true);
        setErro(null);

        ObterTemplatePreviewMensagem(mensagemId)
            .then((res) => {
                if (!mounted) return;

                if (res?.success && res?.data) {
                    // ✅ Cache igual você faz com mídia
                    mensagem._templatePreview = res.data;

                    setPreview(res.data);
                } else {
                    setErro(res?.message || "Preview do template não disponível.");
                }
            })
            .catch(() => {
                if (!mounted) return;
                setErro("Erro ao obter preview do template.");
            })
            .finally(() => {
                if (!mounted) return;
                setLoading(false);
            });

        return () => {
            mounted = false;
        };
    }, [mensagemId, initialPreview]); // ✅ dependências corretas

    const template = useMemo(() => preview?.template || null, [preview]);
    const valoresParametros = useMemo(() => preview?.valoresParametros || {}, [preview]);

    if (loading) return <div>[Carregando template...]</div>;
    if (erro) return <div>[{erro}]</div>;
    if (!template) return <div>[Template não disponível]</div>;

    return (
        <ChatTemplatePreview
            template={template}
            valoresParametros={valoresParametros}
            size="md"
            showLabels={false}
        />
    );
};

export default MensagemTemplate;
